export enum ApiRoutesBanners {
  Banners = "admin/banners",
  BannersReorder = "reorder"
}
